import { render } from "./AppFooter.vue?vue&type=template&id=45910107"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=45910107&lang=scss"
script.render = render

export default script